import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import defaultFlags from '../initFlags/featureFlags';

const getAmplitudeVariantPayload = (name, states, existingflagValue) => {
  if (states?.flags?.amplitude_experiment_flag == 'ON' && states?.variants && name) {
    const variantData = _get(states?.variants, [name.toLowerCase()]);
    if (variantData) {
      if (variantData.value == 'on') {
        return variantData.payload;
      } else {
        return '';
      }
    } else {
      const isMissingFlagValue =
        existingflagValue == null ||
        (typeof existingflagValue === 'object' && _isEmpty(existingflagValue));
      return isMissingFlagValue ? defaultFlags?.flags?.[name?.toLowerCase()] : existingflagValue;
    }
  }
  return existingflagValue;
};

const getAmplitudeExperimentVariant = (name, states) => {
  // console.log('line20', name, states);
  if (states?.flags?.amplitude_experiment_flag === 'ON' && states?.variants && name) {
    const variantData = _get(states?.variants, [name.toLowerCase()]);
    if (variantData) {
      if (variantData.value === 'treatment') {
        return true;
      }
    }
  }
  return false;
};

const getAmplitudeVariantFlag = (name, states, existingflagValue) => {
  if (states?.flags?.amplitude_experiment_flag == 'ON' && states?.variants && name) {
    const variantData = _get(states?.variants, [name.toLowerCase()]);
    if (variantData) {
      if (variantData.value == 'on') {
        return true;
      } else {
        return false;
      }
    } else {
      return existingflagValue;
    }
  }
  return existingflagValue;
};

const getAmplitudeVariantPayloadMap = (names = [], states) => {
  const ABFlagObj = {};
  if (
    states?.flags?.amplitude_experiment_flag == 'ON' &&
    states?.variants &&
    names &&
    names.length > 0
  ) {
    for (var i = 0; i < names.length; i++) {
      var name = names[i];
      const variantData = _get(states?.variants, [name.toLowerCase()]);
      if (variantData) {
        if (variantData.value == 'on') {
          ABFlagObj[name] = variantData.payload;
        }
      }
    }
  }
  return ABFlagObj;
};

export {
  getAmplitudeVariantPayload,
  getAmplitudeVariantFlag,
  getAmplitudeVariantPayloadMap,
  getAmplitudeExperimentVariant
};
